import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { throwIfAlreadyLoaded } from './module-import-guard';
import {
    AuthGuard,
    AuthAnonGuard
} from './guards';
import { APP_INITIALIZER } from '@angular/core';
import { ThemeHelpersService } from '../@theme/helpers/theme-helpers/theme-helpers.service';
import {
    AppConfigService,
    AuthService,
    HomeService,
} from './services';

export const CORE_PROVIDERS = [
    AppConfigService,
    ThemeHelpersService,
    AuthService,
    HomeService,
    AuthGuard,
    AuthAnonGuard,
];

const appInitializerFn = (appConfig: AppConfigService) => {
    return () => {
        return appConfig.loadAppConfig();
    };
};

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
    ],
    declarations: [],
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }

    public static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: appInitializerFn,
                    multi: true,
                    deps: [AppConfigService],
                },
                ...CORE_PROVIDERS,
            ],
        };
    }
}
